module.exports = __webpack_public_path__ + "img/2dada1a.png";